import { render, staticRenderFns } from "./FormLayoutProducts.vue?vue&type=template&id=67f39a34&"
import script from "./FormLayoutProducts.vue?vue&type=script&lang=js&"
export * from "./FormLayoutProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports